export enum AutoFeederType {
    SIMPLE_AUTO_FEEDER = 'simpleAutoFeeder',
    SORTED_AUTO_FEEDER = 'sortedAutoFeeder',
    PRIORITEZED_AUTO_FEEDER = 'prioritizedAutoFeeder',
    SELECTED_AUTO_FEEDER = 'selectedAutoFeeder'
}
